module.exports = __webpack_public_path__ + "img/era.cea9a31e.jpg";